module.exports = __webpack_public_path__ + "img/28.d95cf534.png";